import React, { Component } from 'react'

import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from '../helpers/firebase'
import firebaseui from 'firebaseui'

// Configure FirebaseUI.
export const uiConfig = {
  signInSuccessUrl: '/spaces',
  signInOptions: [
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      requireDisplayName: true,
    }
  ],
  credentialHelper: firebaseui.auth.CredentialHelper.NONE
};


export default class AuthScreen extends Component {
  render() {
    return (
      <div style={Styles.container}>
        <div style={Styles.text}>Welcome to <strong>Just Thank You Admin</strong>. Please Login</div>
        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
      </div>
    )
  }
}
const Styles = {
  container: {
    flexDirection: 'column',
    margin: 20,
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
  },
  text: {
    marginTop: 20,
    marginBottom: 20
  }
}


// WEBPACK FOOTER //
// ./src/components/AuthScreen.js